import { apiFetch } from './api';

/**
 * Évaluation de fin de formation vue par le stagiaire qui détient le lien :
 * les questions SANS barème, ou son résultat s'il a déjà répondu. Aucune
 * authentification — le jeton fait foi.
 */
export function getEvaluationPublique(token) {
  return apiFetch(`/qcm-public/${token}`);
}

/**
 * Envoie les réponses : `infos` (questions communes : e-mail, nom, formateur,
 * entreprise…) et `reponses` [{ questionId, optionIds }]. Renvoie la note et
 * le pourcentage de réussite.
 */
export function soumettreEvaluation(token, { infos, reponses }) {
  return apiFetch(`/qcm-public/${token}`, {
    method: 'POST',
    body: JSON.stringify({ infos, reponses }),
  });
}
